import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

// Full admin access
const ADMIN_UIDS = [
  'gQhTWaS0rDOtPTtVYciqX5g3mTE3',
  'o4ltF8eOpCgEZT2g42bZPmpPxIy1',
];

// SEO writers — see a restricted dashboard pointing them at Sanity Studio
const WRITER_UIDS = [
  'YA99AdVBkYhN0IaYUAZry5lu8Zr1',
  '5v23BT8oWgOCCTjLFlaI5ydckzR2',
];

const AdminAuth = () => {
  const [user, setUser]           = useState(null);
  const [loading, setLoading]     = useState(true);
  const [role, setRole]           = useState(null); // "admin" | "writer" | null
  const [authError, setAuthError] = useState("");

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        console.log("[AdminAuth] logged in uid:", currentUser.uid, "email:", currentUser.email);
        if (ADMIN_UIDS.includes(currentUser.uid)) {
          setRole("admin");
          setAuthError("");
        } else if (WRITER_UIDS.includes(currentUser.uid)) {
          setRole("writer");
          setAuthError("");
        } else {
          setRole(null);
          setAuthError("Access denied — insufficient permissions");
        }
      } else {
        setRole(null);
        setAuthError("");
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-96">
        <div className="text-xl text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <AdminLogin />;
  }

  if (!role) {
    return (
      <div className="flex flex-col items-center justify-center min-h-96">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h2>
          <p className="text-gray-600 mb-4">{authError}</p>
          <p className="text-sm text-gray-500">Logged in as: {user.email}</p>
          <button
            onClick={() => getAuth().signOut()}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  return <AdminDashboard user={user} role={role} />;
};

export default AdminAuth;
